import React, { ReactNode, useContext, useEffect, useState } from 'react';

import CustomersContext from '@totem/components/orgManagement/orgDetails/netSuiteKeys/options/customersContext';
import { NetSuiteCustomers } from '@totem/components/orgManagement/orgDetails/netSuiteKeys/types';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';
import { API_V1 } from '@totem/utilities/endpoints';

type Props = {
  children?: ReactNode;
};

const CustomersContainer = ({ children }: Props) => {
  const { getApiToken } = useContext(UserProfileContext);
  const [data, setData] = useState<NetSuiteCustomers>([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [page, setPage] = useState<number>(0);
  const [pageSize, setPageSize] = useState<number>(50);
  const [refreshData, setRefreshData] = useState<boolean>(true);

  useEffect(() => {
    if (!refreshData) {
      return;
    }

    setRefreshData(false);

    if (searchTerm === '') {
      setData([]);
      return;
    }

    const payload = {
      page,
      pageSize,
      searchTerm,
    };

    fetch(`${API_V1}/customers/search`, {
      method: 'POST',
      headers: new Headers({
        Authorization: `Bearer ${getApiToken()}`,
      }),
      body: JSON.stringify(payload),
    })
      .then((res) => res.json())
      .then((result: NetSuiteCustomers) => {
        setData(result);
      });
  }, [refreshData]);

  const handleSetSearchTerm = (newSearchTerm: string) => {
    setSearchTerm(newSearchTerm);

    setPage(0);

    setRefreshData(true);
  };

  const handleSetPageSize = (newPageSize: number) => {
    setPageSize(newPageSize);

    setPage(0);

    setRefreshData(true);
  };

  return (
    <CustomersContext.Provider
      value={{
        searchTerm,
        page,
        pageSize,
        netSuiteCustomers: data,
        onRefresh: () => setRefreshData(true),
        setSearchTerm: handleSetSearchTerm,
        setPageSize: handleSetPageSize,
        setPage: (newPage: number) => setPage(newPage),
      }}
    >
      {children}
    </CustomersContext.Provider>
  );
};

export default CustomersContainer;
